import React from 'react';
import { Layout as AntLayout } from '@vertem-core/vertice-ds';
import { LayoutProps } from 'antd/lib/layout';

const Layout: React.FC<LayoutProps> & {
  Header: typeof AntLayout.Header;
  Footer: typeof AntLayout.Footer;
  Content: typeof AntLayout.Content;
} = (props:any) => (
    <>
      {props.children}
    </>
  );

Layout.Header = AntLayout.Header;
Layout.Footer = AntLayout.Footer;
Layout.Content = AntLayout.Content;

export default Layout;
